import React from 'react';
import { func, string, bool } from 'prop-types';
import classNames from 'classnames';
import { Checkbox } from 'components';

class CheckboxItem extends React.Component {
    static propTypes = {
        value: string,
        label: string,
        checked: bool,
        className: string,
        onChange: func
    };

    onItemClick = () => {
        const { value, label, onChange } = this.props;

        onChange({ value, label });
    };

    render() {
        const { className, value, label, checked } = this.props;
        const itemClass = classNames('checkbox-item', className);

        return (
            <div className={itemClass}>
                <Checkbox
                    value={value}
                    checked={checked}
                    onChange={this.onItemClick}
                />
                {!!label && <label onClick={this.onItemClick}>{label}</label>}
            </div>
        );
    }
}

export default CheckboxItem;
